<template>
  <v-container v-if="loading" fill-height :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout align-center justify-center>
      <v-flex xs12>
        <loading/>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container fluid :pa-0="$vuetify.breakpoint.smAndDown" v-else>
    <v-card>
      <v-card-title>
        <document-toolbar
            :id="id"
            :name="name"
            :title="title"
            :created_on="document.created_on"
            :addItems="true"
            @openDocument="openDocument"
            @closeDocument="closeDocument"
        />
      </v-card-title>
      <v-card-text>
        <form>
          <v-textarea
              v-model="document.comment"
              auto-grow
              name="comment"
              id="comment"
              label="Комментарий"
              rows="1"
          ></v-textarea>
        </form>
      </v-card-text>
      <component
          :is="rezervirovanieComponent"
          @openOptionsDialog="openOptionsDialog"
          :records="document.records"
          @deleteRow="deleteRow"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="excel" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-file-excel
          </v-icon>
          <template v-else>
            Excel
          </template>
        </v-btn>
        <v-btn
            color="red"
            :dark="!saving && !writingout"
            @click="deleteDocument"
            :icon="$vuetify.breakpoint.xsOnly"
            :disabled="saving || writingout"
        >
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-delete
          </v-icon>
          <template v-else>
            Удалить
          </template>
        </v-btn>
        <v-btn
            color="accent"
            @click="showWriteoutConfirmationModal"
            :icon="$vuetify.breakpoint.xsOnly"
            :disabled="document.records.length === 0 || saving || commonQty <= 0"
            :loading="writingout"
        >
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-check-outline
          </v-icon>
          <template v-else>
            Выписать
          </template>
        </v-btn>
        <v-btn
            color="green"
            :dark="document.records.length > 0 && !writingout && commonQty > 0"
            @click="saveDocument()"
            :icon="$vuetify.breakpoint.xsOnly"
            :disabled="document.records.length === 0 || writingout || commonQty <= 0"
            :loading="saving"
        >
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-content-save
          </v-icon>
          <template v-else>
            Сохранить
          </template>
        </v-btn>
        <v-btn color="secondary" @click="closeDocument" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-close
          </v-icon>
          <template v-else>
            Закрыть
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
        :color="messageType"
        :timeout="5000"
        :bottom="true"
        v-model="messageDisplay"
    >
      {{ messageText }}
      <v-btn flat icon @click.native="messageDisplay = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <rezervirovanie-writeout-modal
        ref="writeoutConfirmationModal"
        @ok="writeoutDocument"
    />
    <rezervirovanie-message-modal
        ref="messageModal"
        @confirm="forceSaveDocument"
    />
      <product-options
          ref="productOptions"
          @updateDocumentRecord="updateDocumentRecord"
      />
  </v-container>
</template>

<script>
import DocumentsApi from '../api'
import rezervirovanieTable from './RezervirovanieTable'
import rezervirovanieList from './RezervirovanieList'
import ProductOptions from '@/components/common/ProductOptions'
import documentTweaks from '../mixins/documentTweaks'
import editableDocumentTweaks from '../mixins/editableDocumentTweaks'
import rezervirovanieWriteoutModal from './RezervirovanieWriteoutModal'
import rezervirovanieMessageModal from './RezervirovanieMessageModal'
import { map } from 'lodash'

export default {
  name: 'rezervirovanie',
  mixins: [
    documentTweaks,
    editableDocumentTweaks
  ],
  components: {
    rezervirovanieTable,
    rezervirovanieList,
    rezervirovanieWriteoutModal,
    rezervirovanieMessageModal,
    ProductOptions
  },
  data () {
    return {
      writingout: false,
      name: 'rezervirovanie',
      title: 'Резервирование'
    }
  },

  computed: {
    rezervirovanieComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'rezervirovanie-list' : 'rezervirovanie-table'
    }
  },
  methods: {
    showWriteoutConfirmationModal () {
      this.$refs.writeoutConfirmationModal.open(this.id)
    },
    async writeoutDocument (tipDostavki, address) {
      this.writingout = true
      let response = await DocumentsApi.writeoutDocument({
        tip_dostavki: tipDostavki,
        address: address,
        id: this.id
      })
      if (response.success) {
        this.writingout = false
        this.$router.push({ name: 'documents' })
        // this.$router.push({
        //   name: `documents/${response.document.name}`,
        //   params: { docId: response.document.id }
        // })
      } else {
        this.writingout = false
        if (response.message) {
          this.$refs.messageModal.open(response.message)
        }
      }
    },
    getRecordsForSave () {
      return map(this.document.records, (record) => {
        return {
          nomenklatura_id: record.nomenklatura_id,
          kolichestvo: record.kolichestvo,
          tsena: record.tsena,
          attributes: record.attributes,
          toppings: record.toppings
        }
      })
    },
    deleteRow (item) {
      const index = this.document.records.indexOf(item)
      this.document.records.splice(index, 1)
    },
    openOptionsDialog (item) {
      this.$refs.productOptions.open(item, false, this.id, 0)
    },
    updateDocumentRecord (item) {
      let record = this.document.records.find((record) => record.nomenklatura_id === item.nomenklatura_id)
      Object.assign(record, item)
    }
  }
}
</script>

<style lang="stylus">
.table-qty {
  border: 1px solid rgba(0, 0, 0, 0.12);
  width: 50px;
  margin: 0;
  text-align: right;
  padding: 5px;
  outline: none;
}
</style>
